import { render, staticRenderFns } from "./RFMPanel.vue?vue&type=template&id=22556e32"
import script from "./RFMPanel.vue?vue&type=script&lang=js"
export * from "./RFMPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports